<template lang="pug">
  v-flex 
    v-card
      v-card-title Productos
        v-spacer
        v-text-field(v-model='search' append-icon='fa-search' label='Buscar producto' single-line hide-details)
        
        MassiveProductDialog
        v-dialog(v-model='Product.dialog' max-width='500px')
          template(v-slot:activator='{ on }')
            v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
          v-card
            v-card-title Registro
            v-card-text
              v-layout(wrap)
                v-flex(xs12 sm6 d-flex)
                  v-autocomplete(v-model='data.codigo_producto_sunat' :items='productTypeRecord' :item-text='item=>`${item.codigo_producto_sunat} - ${item.descripcion}`' item-value='codigo_producto_sunat' label='Tipo de Producto')
                v-flex(xs12 sm6 d-flex)
                  v-select(v-model='data.unidad_de_medida' :items='tipo_unidad_de_medida' item-text='label' item-value='value' label='Unidad de medida')
                  p(:v-html='data.nombre_unidad_de_medida = data.unidad_de_medida ? tipo_unidad_de_medida.filter(item=>item.value == data.unidad_de_medida)[0].label : ""')
                v-flex(xs12 sm6 d-flex)
                  v-text-field(v-model='data.codigo' label='Código')
                v-flex(xs12 sm6 d-flex)
                  v-text-field(v-model='data.presentacion' label='Presentación')
                v-flex(xs12 sm6 d-flex)
                  v-text-field(v-model='data.descripcion' label='Descripción')
            v-card-actions
              v-spacer
              v-btn(color='primary' @click='save()') Guardar
      v-data-table.elevation-1(:headers='headers' :items='productsRecord' :search='search' key='key')
        template(v-slot:item.action='{item}')
          v-btn(color='secondary' icon @click='editItem(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(item.key)')
            v-icon(small) far fa-trash-alt

</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import tipo_unidad_de_medida from '@/jsons/tipo_de_unidad_de_medida.json'
export default {
  data:()=>({
      headers: [
        { text: 'Código', value: 'codigo' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Presentación', value: 'presentacion' },

        { text: 'Tipo de producto', value: 'codigo_producto_sunat' },
        { text: 'Unidad de medida', value: 'nombre_unidad_de_medida' },
        {text:'Acciones',value:'action'}
      ],
      search: '',
      tipo_unidad_de_medida
  }),
  methods:{
     ...mapActions({
      editItem: 'Product/get',
      deleteItem: 'Product/clean',
      save: 'Product/add',
      clearForm: 'Product/clearForm',
    }),
  },

  computed: {
    ...mapGetters({
      productsRecord: 'Product/record',
      productTypeRecord: 'ProductType/record',
    }),
    ...mapState({
      data: state=> state.Product.data,
      Product: state=> state.Product,
    }),
  },
  
  components: {
    MassiveProductDialog: ()=>import('.././components/MassiveProductDialog')
  },
}
</script>
